// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import SearchIcon from 'mz-icons/search';
import Button from 'mz-ui-kit/core/Button';
import Tooltip from 'mz-ui-kit/core/Tooltip';
import { Container, ButtonWrapper } from './elements';
import { FormattedMessage } from 'mz-intl';
import messages from '../../messages.intl';

// types
type Props = {
  className: string,
  disabled: boolean,
  outdated: boolean
};

class SearchButton extends Component<Props> {
  renderButton = (innerRef = null) => {
    const { disabled } = this.props;
    return (
      <Button
        innerRef={innerRef}
        type="submit"
        disabled={disabled}
        size="small"
      >
        <SearchIcon size="lg" />
      </Button>
    );
  };

  render() {
    const { outdated } = this.props;
    return (
      <Container>
        <Tooltip
          showed={outdated}
          width="160px"
          color="yellow"
          placement="bottom"
          wrapper={ButtonWrapper}
          target={this.renderButton}
          content={() => (
            <FormattedMessage message={messages.SEARCH_BUTTON_TOOLTIP} />
          )}
        />
      </Container>
    )
  }
}

const mapStateToProps = (state) => ({
  outdated: state.searchResults.outdated
});

export default connect(mapStateToProps)(SearchButton);
